import { Component, Input } from '@angular/core';

@Component({
  selector: 'currency-why-trade',
  templateUrl: './currency-why-trade.component.html',
  styleUrls: ['./currency-why-trade.component.scss']
})
export class CurrencyWhyTradeComponent {
  @Input() content: string;
  @Input() currencyName: string;
}
